// illustrationsRegistry.js
// Engagement
import RecognitionHomeEmptyState from '../../assets/illustrations/kincode-recognition-home-emptyState.png';
import RecognitionLeaderboardEmptyState from '../../assets/illustrations/kincode-recognition-leaderboard-emptyState.png';

import PulseDataEmptyState from '../../assets/illustrations/kincode-pulse-home-data-emptyState.png';
import PulseSurveysEmptyState from '../../assets/illustrations/kincode-pulse-surveys-emptyState.png';
import PulseDriversEmptyState from '../../assets/illustrations/kincode-pulse-drivers-emptyState.png';
import PulseQuestionsEmptyState from '../../assets/illustrations/kincode-pulse-questions-emptyState.png';
import PulseConfidential from '../../assets/illustrations/kincode-pulse-confidential-dashboard.png';

import OneOnOnesHistoryEmptyState from '../../assets/illustrations/kincode-1on1s-history-emptyState.png';

// Performance
import CalibrationTeamEmptyState from '../../assets/illustrations/kincode-calibration-team-emptyState.png';

// Development
// import { ReactComponent as Onboarding } from '../../assets/icons/onboarding.svg';
import CareerConversationsEmptyState from '../../assets/illustrations/kincode-career-conversations-emptyState.png';
import CareerGuidelinesEmptyState from '../../assets/illustrations/kincode-career-guidelines-emptyState.png';

// Essentials
import OrganigramEmptyState from '../../assets/illustrations/kincode-organigram-emptyState.png';
import EmployeeListEmptyState from '../../assets/illustrations/kincode-employeeList-emptyState.png';
import HRInboxEmptyState from '../../assets/illustrations/kincode-inbox-emptyState.png';

// Goals
// TODO: Create kincode-goals-home-emptyState.png illustration and uncomment the import below
// import GoalsHomeEmptyState from '../../assets/illustrations/kincode-goals-home-emptyState.png';

// Data
import DataEmptyState from '../../assets/illustrations/kincode-home-data-emptyState.png';
// import ToDosEmptyState from '../../assets/illustrations/kincode-home-toDos-emptyState.png';
import ToDosEmptyState from '../../assets/illustrations/KAI_empty_todos_relaxing.png';
// KAI
import KAIProfilePicture from '../../assets/illustrations/KAI profile pic.png';
import KAIProfilePictureLong from '../../assets/illustrations/KAI profile pic long.png';
// Error Pages
import ErrorPageBackground from '../../assets/illustrations/illustrations-errorPage.png';
import Kai404Illustration from '../../assets/illustrations/KAI_404.png';
import Kai500Illustration from '../../assets/illustrations/KAI_500.png';

// -------------------------------------------------------------
// Illustrations Registry
// -------------------------------------------------------------
const assets = {
  // Engagement
  RecognitionHomeEmptyState,
  RecognitionLeaderboardEmptyState,

  PulseDataEmptyState,
  PulseSurveysEmptyState,
  PulseDriversEmptyState,
  PulseQuestionsEmptyState,
  PulseConfidential,

  OneOnOnesHistoryEmptyState,

  // Performance
  CalibrationTeamEmptyState,

  // Development
  CareerConversationsEmptyState,
  CareerGuidelinesEmptyState,

  // Essentials
  OrganigramEmptyState,
  EmployeeListEmptyState,
  HRInboxEmptyState,
  DataEmptyState,
  ToDosEmptyState,

  // Goals
  // GoalsHomeEmptyState, // Uncomment when illustration is created
  GoalsHomeEmptyState: ToDosEmptyState, // Temporary fallback - replace with actual Goals illustration when ready

  // KAI
  KAIProfilePicture,
  KAIProfilePictureLong,

  // Error Pages
  ErrorPageBackground,
  KAI404: Kai404Illustration,
  KAI500: Kai500Illustration,
};

// -------------------------------------------------------------
// 👇 Optional: Also export the unified Icon component from here
export const Illustrations = ({ name, className = 'w-80 h-80' }) => {
  const Image = assets[name];
  return Image ? <img src={Image} className={className} alt={name} /> : null;
};
